import { CalendarClockIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { ScheduledMessage } from '@/shared/types/scheduledMessage';

import { formatScheduledAt, getTemplateBodyPreview } from './utils';

interface Props {
  message: ScheduledMessage;
  onCancel: (scheduledMessageId: string) => void;
  canCancel: boolean;
  isCancelling?: boolean;
}

const ScheduledMessageCard = ({ message, onCancel, canCancel, isCancelling }: Props) => {
  const { t } = useTranslation();

  return (
    <div data-testid="scheduled-message-card" className="flex flex-col gap-1 p-3">
      <div className="flex items-center justify-between gap-2">
        <div className="flex min-w-0 items-center gap-2">
          <CalendarClockIcon size={16} className="shrink-0 text-muted-foreground" />
          <span className="truncate text-sm font-semibold text-foreground">
            {t('scheduled_messages.scheduled_for', { 0: formatScheduledAt(message.scheduled_at) })}
          </span>
        </div>
        {canCancel && (
          <Button
            type="button"
            variant="destructive-ghost"
            size="sm"
            disabled={isCancelling}
            onClick={() => onCancel(message.scheduled_message_id)}
          >
            {t('common.cancel')}
          </Button>
        )}
      </div>
      <p className="line-clamp-3 pl-6 text-sm text-muted-foreground">
        {getTemplateBodyPreview(message.template)}
      </p>
    </div>
  );
};

export default ScheduledMessageCard;
